<template>
    <div>
        <v-layout row wrap class="hidden-sm-and-up">
            <v-flex v-for="item in quotes" :key="item.id"
                xs12 sm6 md4 lg3
            >
                <v-card >
                <v-card-title class="text-xs-center accent" :class="jobColor(item.statusId)" height="40">
                    <v-spacer></v-spacer>
                    <h4>{{ item.num }} - {{ item.statusId }}</h4>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text row wrap style="padding-bottom: 3px;">
                    <v-layout>
                        <v-flex body-2 text-xs-center pb-1 no-wrap text-truncate>{{ item.facilityName }}</v-flex>
                    </v-layout>
                    <v-layout>
                    <v-flex xs4 body-2 pt-1>Quote Date:</v-flex>
                    <v-flex xs8 text-xs-left pt-1>{{ item.quoteDate }}</v-flex>
                    </v-layout>

                    <v-layout>
                    <v-flex xs4 body-2 pt-1>Total Amt.:</v-flex>
                    <!-- <v-flex xs8 text-xs-left pt-1>{{ item.totalAmount | toCurrency }}</v-flex> -->
                    <v-flex xs8 text-xs-left pt-1>
                        {{ formatCurrency((!item.totalAmount? 0 : item.totalAmount), item.currnIdx) }}
                    </v-flex>
                    
                    </v-layout>
                    <v-layout>
                    <v-flex xs4 body-2 pt-1>Acct. #:</v-flex>
                    <v-flex xs8 text-xs-left pt-1>{{ item.facilityAcctNo }}</v-flex>
                    </v-layout>
                    <!-- <v-layout>
                    <v-flex xs4 body-2 pt-1>Territory:</v-flex>
                    <v-flex xs8 text-xs-left pt-1>{{ item.facilityTerritory }}</v-flex>
                    </v-layout> -->
                    <v-layout>
                    <v-flex xs4 body-2 pt-1>Contact:</v-flex>
                    <v-flex xs8 text-xs-left pt-1>{{ item.contactName }}</v-flex>
                    </v-layout>
                    <v-layout>
                    <v-flex xs4 body-2 pt-1>Phone:</v-flex>
                    <v-flex xs8 text-xs-left pt-1>{{ item.phone }}</v-flex>
                    </v-layout>
                    <!-- <v-layout>
                    <v-flex xs4 body-2 pt-1>Email:</v-flex>
                    <v-flex xs8 text-xs-left pt-1>{{ item.email }}</v-flex>
                    </v-layout> -->
                    <v-layout>
                    <v-flex xs4 body-2 pt-1>Sales Rep.:</v-flex>
                    <v-flex xs8 text-xs-left pt-1>{{ item.salesRep.name }}</v-flex>
                    </v-layout>
                    <v-layout>
                    <v-flex xs4 body-2 pt-1>Cs Rep.:</v-flex>
                    <v-flex xs8 text-xs-left pt-1>{{ item.csRep.name }}</v-flex>
                    </v-layout>
                    <v-layout>
                    <v-flex xs4 body-2 pt-1>Inside Rep.:</v-flex>
                    <v-flex xs8 text-xs-left pt-1>{{ item.isRep.name }}</v-flex>
                    </v-layout>
                    <!-- <v-layout>
                    <v-flex xs4 body-2 pt-1>Create By:</v-flex>
                    <v-flex xs8 text-xs-left pt-1>{{ item.createBy }}</v-flex>
                    </v-layout> -->
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="primary" @click.prevent="$emit('viewQuote', props.item.id)">View</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>

    </div>
</template>
<script>
import ctlQuoteItemEdit from '@/components/public/ctlQuoteItemEdit'
export default {
    props: ['quotes'],
    components: {
    },
    data() {
        return {
            // headers: [
            //     { text: '#', sortable: false},
            //     { text: 'Status', sortable: false},
            //     { text: 'Facility', sortable: false},
            //     { text: 'Quote Date' , sortable: false},
            //     { text: 'Total Amt.' , sortable: false, align: 'center'},
            //     { text: 'Acct. #' , sortable: false},
            //     { text: 'Contact' , sortable: false},
            //     { text: 'Phone' , sortable: false},
            //     { text: 'Sales Rep.' , sortable: false},
            //     { text: 'CS Rep.' , sortable: false},
            //     { text: 'IS Rep.' , sortable: false},
            //     // { text: 'QTY', sortable: false, class: ['px-1']},
            //     // { text: 'PRICE LEVEL' , sortable: false},
            //     // { text: 'DISCOUNT' , sortable: false},
            //     // { text: 'TOTAL' , sortable: false, align: 'right'},
            //     // { text: 'Notes', value: 'notes', sortable: false, class: ['px-1']},
            //     // { text: '', sortable: false}
            // ],
        }
    },
    computed: {
    },
    methods: {
        jobColor (jobStatus) {
            if (jobStatus === 'Cancelled') {
                return 'red--text lighten-3'
            }
            if (jobStatus === 'Lost') {
                return 'red--text lighten-3'
            }
            if (jobStatus === 'NeedMoreInfo') {
                return 'orange--text lighten-3'
            }
            if (jobStatus === 'Editing') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Processing' 
                || jobStatus === 'DiscountApproved') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Revising') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Won') {
                return 'green--text lighten-3'
            }
            if (jobStatus === 'SentToCustomer') {
                return 'purple--text lighten-3'
            }
            if (jobStatus === 'WaitingForProcess') {
                return 'blue--text lighten-3'
            }
        },

    }
}
</script>
